(() => {
  if (window.RoyalThreadsSizeGuideReadyV3) return;
  window.RoyalThreadsSizeGuideReadyV3 = true;

  const storageKey = 'royal-threads-size-guide-unit';

  const savedUnit = () => {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  };

  const rememberUnit = (unit) => {
    try {
      window.localStorage.setItem(storageKey, unit);
    } catch (error) {
      // Storage can be unavailable in private browsing; the dialog still works.
    }
  };

  const setUnit = (dialog, unit, persist = false) => {
    const availableUnit = dialog.querySelector(`[data-rt-size-guide-panel="${unit}"]`) ? unit : 'inches';

    dialog.querySelectorAll('[data-rt-size-guide-unit]').forEach((tab) => {
      const selected = tab.dataset.rtSizeGuideUnit === availableUnit;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    dialog.querySelectorAll('[data-rt-size-guide-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.rtSizeGuidePanel !== availableUnit;
    });

    if (persist) rememberUnit(availableUnit);
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-rt-size-guide-open]');
    if (opener) {
      event.preventDefault();
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog) return;

      setUnit(dialog, savedUnit() || dialog.dataset.defaultUnit || 'inches');
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        document.documentElement.classList.add('rt-size-guide-open');
      }
      dialog.querySelector('[role="tab"][aria-selected="true"]')?.focus();
      dialog.addEventListener('close', () => opener.focus(), { once: true });
      return;
    }

    const closeButton = event.target.closest('.rt-size-guide__close');
    if (closeButton) {
      event.preventDefault();
      const dialog = closeButton.closest('dialog');
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('rt-size-guide-open');
      return;
    }

    const zoomButton = event.target.closest('[data-rt-size-guide-zoom]');
    if (zoomButton) {
      const panel = zoomButton.closest('[data-rt-size-guide-panel]');
      if (!panel) return;

      const zoomed = panel.classList.toggle('is-zoomed');
      const label = zoomButton.querySelector('[data-rt-size-guide-zoom-label]');
      zoomButton.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
      if (label) label.textContent = zoomed ? zoomButton.dataset.zoomOut : zoomButton.dataset.zoomIn;

      if (!zoomed) {
        panel.querySelector('.rt-size-guide__image-scroll')?.scrollTo({ left: 0, behavior: 'smooth' });
      }
      return;
    }

    const unitButton = event.target.closest('[data-rt-size-guide-unit]');
    if (unitButton) {
      const dialog = unitButton.closest('dialog');
      if (!dialog) return;

      setUnit(dialog, unitButton.dataset.rtSizeGuideUnit, true);
      unitButton.focus();
      return;
    }

    if (event.target.matches('dialog.rt-size-guide')) {
      if (typeof event.target.close === 'function') event.target.close();
      else event.target.removeAttribute('open');
      document.documentElement.classList.remove('rt-size-guide-open');
    }
  }, true);

  const bindSizeGuideOpeners = (root = document) => {
    root.querySelectorAll('[data-rt-size-guide-open]:not([data-rt-size-guide-bound])').forEach((opener) => {
      opener.dataset.rtSizeGuideBound = 'true';
      opener.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const dialog = document.getElementById(opener.getAttribute('aria-controls'));
        if (!dialog) return;
        setUnit(dialog, savedUnit() || dialog.dataset.defaultUnit || 'inches');
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else {
          dialog.setAttribute('open', '');
          document.documentElement.classList.add('rt-size-guide-open');
        }
      }, true);
    });
  };

  bindSizeGuideOpeners();
  new MutationObserver(() => bindSizeGuideOpeners()).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('keydown', (event) => {
    const currentTab = event.target.closest('[data-rt-size-guide-unit]');
    if (!currentTab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

    const tabs = [...currentTab.closest('[role="tablist"]').querySelectorAll('[data-rt-size-guide-unit]')];
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextTab = tabs[(tabs.indexOf(currentTab) + direction + tabs.length) % tabs.length];

    event.preventDefault();
    nextTab.click();
  });
})();
